import React from "react";
import {getMonthYearFrench} from "./utils";
import styled from "styled-components";
import {getImage} from "../../utils/utils";
import logoEYB from "../../images/logo_EYB/logoEYBFull.png"

const Header = ({strategy, handlePrint}) => {
    const today = new Date().toLocaleDateString("fr");
    const monthYear = getMonthYearFrench();

        return (
            <EnjoyNewsHeader>
                <div className="title-section">
                    <div>
                        <img src={getImage(strategy.image, logoEYB )} alt="logo"/>
                    </div>
                    <div>
                        <p className="title">Enjoy News</p>
                        <p className="sub-title">La synthèse de votre stratégie</p>
                    </div>
                </div>
                <div className="info-mini">
                    <p>Données au {today}</p>
                    <p>www.enjoyyourbusiness.fr</p>
                </div>
                <div className="info">
                    <div className="info-date">
                        <p>{monthYear}</p>
                    </div>
                    <div className="info-env">
                        <p> {process.env.REACT_APP_FQDN} </p>
                    </div>
                </div>
            </EnjoyNewsHeader>
        );
}
export default Header;

const EnjoyNewsHeader = styled.header`
  .title-section{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    @media screen and (min-width: 1250px){
      flex-direction: row;
    }
    
    @media print{
      flex-direction: row;
    }
  }

  .title-section img{
    min-width:70% ;
    
    @media print{
      max-width: 80%;
    }
  }

  .title{
    color: #5e2ca5;
    margin: 0.5rem 0;
    font-family: 'Archivo Black', sans-serif;
    font-size: 70px;
    text-align: center;

    @media screen and (min-width: 900px){
      font-size: 100px;
      text-align: right;
    }
    @media screen and (min-width: 1350px){
      font-size: 110px;
    }
    
    @media print {
      font-size: 50px;
    }
  }

  .sub-title{
    font-size: 32px;
    text-align: center;
    @media screen and (min-width: 900px){
      font-size: 45px;
      text-align: end;
    }
    @media print{
      text-align: end;
      margin: 0;
      font-size: 22px;
    }
  }

  .info-mini{
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
    padding: 0 0.5rem;
    @media print {
      padding: 0;  
      margin-top: 0;
  }
  }
  .info-mini p{
    margin: 0;
  }

  .info{
    display: flex;
    gap:0.2rem;
    text-align: center;
    @media screen and (min-width: 600px){
      gap: 1rem;
    }
    @media print {
      gap: 0.5rem;
    }
  }

  .info-date{
    padding: 0.5rem;
    background: #5e2ca5;
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    p{
      color: white;
      font-weight: bold;
      font-size: 18px;
      @media screen and (min-width: 600px){
        font-size: 26px;
        width: 20%;
      }
      @media screen and (min-width: 900px){
        font-size: 25px;
      }

      @media print {
        font-size: 19px;
      }
    }

  }

  .pdf{
    padding: 0.5rem;
    background: #E9405B;
    display: none;
    width: 20%;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    p{
      color: white;
      font-weight: bold;
      font-size: 20px;
    }
    @media print{
      display: none;
    }
    @media screen and (min-width: 900px){
      display: flex;
    }
  }
  .pdf-tel{
    padding: 0.5rem;
    background: #E9405B;
    width: 40%;
    text-align: center;
    margin: auto;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    p{
      color: white;
      font-weight: bold;
      font-size: 20px;
    }
    @media screen and (min-width: 900px){
      display: none;
    }
    @media print{
      display: none;
    }
  }

  .info-env{
    padding: 0.5rem;
    background: #3394F6;
    width: 60%;
    display: flex;
    align-items: center; 
    justify-content: center;
    @media screen and (min-width: 600px){
      width: 80%;
    } 
    
    @media print{
      width: 80%;
    }
    p{
      color: white;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 18px;
      @media screen and (min-width: 600px){
        font-size: 26px;
      }
      @media screen and (min-width: 900px){
        font-size: 35px;
      }
      
      @media print{
        font-size: 21px;
      }
    }
  }
`
